'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteFeatures = void 0;
var transport_1 = require("../../transport");
var SiteFeatures = /** @class */ (function () {
    function SiteFeatures() {
    }
    SiteFeatures.prototype.fetch = function () {
        return transport_1.transport.request('sitefeatures/fetch');
    };
    return SiteFeatures;
}());
exports.SiteFeatures = SiteFeatures;
